import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getPageContentByType,
  updatePageContentByType,
} from "store/actions/globalSettingSlice";
import { showAlert } from "store/reducers/alertReducer";
import Spinners from "components/common/Spinners";
import { Col, Container, Row } from "react-bootstrap";
import { Form, Formik } from "formik";
import CustomField from "components/common/CustomField";
import DetailsPageTitle from "components/common/DetailsPageTitle";
import { cancellationPolicySchema } from "components/common/Validation";
import { setPageTitle } from "components/common/Utils";

const CancellationPolicies = () => {
  const { t } = useTranslation();
  setPageTitle("Cancellation Policies" ,t)

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoading, loading, pageContent } = useSelector(
    (state) => state.GlobalSettings
  );

  const [formValues, setFormValues] = useState({
    description: "",
    descriptionAr: "",
  });

  useEffect(() => {
    const payload = {
      type: "CancellationPolicy",
    };
    dispatch(getPageContentByType(payload));
  }, []);

  useEffect(() => {
    if (pageContent) {
      const { description, descriptionAr } = pageContent || {};

      setFormValues({
        description,
        descriptionAr,
      });
    }
  }, [pageContent]);

  const handleOnSubmit = (values) => {
    const { description, descriptionAr } = values || {};

    const { title, titleAr } = pageContent || {};
    const payload = {
      type: "CancellationPolicy",
      title,
      titleAr,
      description,
      descriptionAr,
    };
    dispatch(updatePageContentByType(payload))
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
          navigate(-1)
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  return (
    <React.Fragment>
      <div className="page-content common_page cancellation_policy_page">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <DetailsPageTitle title={t("Cancellation Policies")} />
            <Formik
              initialValues={formValues}
              enableReinitialize
              validationSchema={cancellationPolicySchema}
              onSubmit={handleOnSubmit}
            >
              {({ errors, touched, values, setFieldValue }) => (
                <Form>
                  <div className="common_wrapper">
                    <Row>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomField
                            name={`description`}
                            placeholder="Enter Description"
                            as="textarea"
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomField
                            name={`descriptionAr`}
                            placeholder="ادخل وصف"
                            as="textarea"
                            isArabic={true}
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="g_end gap-3">
                          <button
                            className="cancel_btn"
                            type="button"
                            onClick={() => navigate(-1)}
                          >
                            {t("Cancel")}
                          </button>
                          <button
                            id="submitBtn"
                            className="main_btn"
                            type="submit"
                            disabled={isLoading}
                          >
                            {t("Update")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Form>
              )}
            </Formik>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default CancellationPolicies;
